const listaDeTarefasMobilidades = (state) => {
    return state.items || [];
}

const listaDeMetodosAssociados = (state) => {
    return state.items;
}

const listaDeTarefasDestino = (state) => {
    return state.tarefasDestino || [];
}

const loadingTarefasMobilidades = (state) => {
    return state.carregando
}

const tarefaMobilidadeSelecionada = (state) => {
    return state.selecionado
}

const listaDeMobilidadesTarefaOrigem = (state) => {
    return state.mobilidadesTarefa
}

const listaDeMobilidadesFormulario = (state) => {
    return state.mobilidadesFormulario
}

const loadingFormulariosMobilidades = (state) => {
    return state.carregandoMobilidadeFormulario
}

const listaDeOpcoesFormulario = (state) => {
    return state.opcoesFormulario
}

const loadingFormulariosOpcoes = (state) => {
    return state.carregandoOpcoesFormulario
}

export {
    listaDeTarefasMobilidades,
    listaDeTarefasDestino,
    loadingTarefasMobilidades,
    tarefaMobilidadeSelecionada,
    listaDeMobilidadesTarefaOrigem,
    listaDeMetodosAssociados,
    listaDeMobilidadesFormulario,
    loadingFormulariosMobilidades,
    listaDeOpcoesFormulario,
    loadingFormulariosOpcoes
}